export function getFormData(data) {
  const {
    Id = '',
    Name = '',
    Type = '',
    IsRequired = false,
    ProductId = ''
  } = data || {};

  return {
    Id,
    Name,
    Type,
    IsRequired,
    ProductId
  };
}